import { Instance, SnapshotIn, types, flow, getEnv, getSnapshot } from 'mobx-state-tree';
import { IStoresEnv } from '@core/storesEnv';

import { convertStringsToOptions } from '@shared/helpers/form';
import {
    performGetProceduresDevices,
    performGetProceduresModes,
} from '../../Procedures/services';

export const ExecutionsFiltersOptionsStoreInferred = types
    .model('ExecutionsFiltersOptionsStoreInferred',
        {
            devices: types.array(types.string),
            modes: types.array(types.string),
        })
    .views(self => ({
        get getFilterOptions() {
            return getSnapshot(self);
        },
        get getDevicesOptions() {
            return convertStringsToOptions(self.devices);
        },
        get getModesOptions() {
            return convertStringsToOptions(self.modes);
        },
    }))
    .actions(self => {
        const { api } = getEnv<IStoresEnv>(self);

        const loadDevices = flow(function* () {
            const result = yield performGetProceduresDevices(
                api,
                {
                    payload: {},
                    errorHandlers: { DEFAULT: '' },
                },
            );

            self.devices = result.data;
        });

        const loadModes = flow(function* () {
            const result = yield performGetProceduresModes(
                api,
                {
                    payload: {},
                    errorHandlers: { DEFAULT: '' },
                },
            );

            self.modes = result.data;
        });

        const loadFilterOptions = flow(function* () {
            yield Promise.all([
                loadDevices(),
                loadModes(),
            ])
        });

        return {
            loadFilterOptions,
        }
    })

type ExecutionsFiltersOptionsStoreFactoryType = typeof ExecutionsFiltersOptionsStoreInferred;
interface IExecutionsFiltersOptionsStoreFactory extends ExecutionsFiltersOptionsStoreFactoryType { }
export const ExecutionsFiltersOptionsStore:
    IExecutionsFiltersOptionsStoreFactory = ExecutionsFiltersOptionsStoreInferred;
export interface IExecutionsFiltersOptionsStore extends Instance<IExecutionsFiltersOptionsStoreFactory> { }
export interface IExecutionsFiltersOptionsStoreSnapshotIn extends SnapshotIn<IExecutionsFiltersOptionsStore> { }
